import React from 'react';
import { Box, Flex } from 'rebass';
import { SearchInput } from '../Form';

type Props = {
  children?: React.ReactNode;
  searchLabel: string;
  placeholder: string;
  search: string;
  onSearchChange: (value: string) => void;
};

export default function WaterServiceListFilters({
  children,
  searchLabel,
  placeholder,
  search,
  onSearchChange,
}: Props) {
  return (
    <Flex mb={2} p="2px" alignItems="center" sx={{ gap: 2 }}>
      <Box
        flex={1}
        minWidth={0}
        maxWidth={300}
        sx={{ '> div': { width: '100%' } }}
      >
        <SearchInput
          aria-label={searchLabel}
          placeholder={placeholder}
          value={search}
          onChange={(event) => onSearchChange(event.target.value)}
          width="100%"
        />
      </Box>
      {children && (
        <Box width={160} flexShrink={0}>
          {children}
        </Box>
      )}
    </Flex>
  );
}
